import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e3ec4a72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-goods-list" }
const _hoisted_2 = {
  key: 0,
  class: "active-tag"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "outer-sphere" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = { class: "standard" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font = _resolveComponent("font")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "goods-image",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goodsDetails($props.good_objs.goods_id)))
    }, [
      ($props.good_objs.icon_url)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _ctx.webpFilters($props.good_objs.icon_url),
              alt: ""
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("img", {
        src: _ctx.webpFilters($props.good_objs.goods_image_url)
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h3", {
        class: "goods-name",
        innerHTML: $props.good_objs.name,
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goodsDetails($props.good_objs.goods_id)))
      }, null, 8, _hoisted_6),
      _createElementVNode("div", {
        class: "goods-price",
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.goodsDetails($props.good_objs.goods_id)))
      }, [
        _createElementVNode("p", null, [
          _createElementVNode("b", null, _toDisplayString($setup.currencyUnit), 1),
          _createTextVNode(" " + _toDisplayString(parseInt($props.good_objs.promotion_price).thousands()), 1)
        ]),
        _hoisted_7,
        _createElementVNode("span", null, [
          _createVNode(_component_font, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.currencyUnit), 1)
            ]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(parseInt($props.good_objs.marketprice).thousands()), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_van_icon, {
          name: "delete",
          size: "18",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.deleteClick($props.good_objs.goods_id,$props.index))),
          class: "end_align"
        }),
        _createVNode(_component_van_button, {
          icon: "cart-o",
          color: "#f76900",
          type: "primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.addGoodsCart($props.good_objs.goods_id)))
        })
      ])
    ])
  ]))
}